export default __webpack_public_path__ + "static/media/game_results_banner_v2.3b9fa834.png";